function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M2305 4275 c-634 -103 -1143 -505 -1381 -1093 -222 -547 -131 -1207 231 -1682 511 -670 1417 -889 2170 -525 649 313 1047 1001 987 1708 -15 173 -32 257 -82 410 -197 591 -698 1033 -1325 1167 -132 29 -464 37 -600 15z m1105 -865 c11 -11 20 -27 20 -35 0 -8 -96 -207 -213 -443 -118 -235 -219 -449 -226 -476 -38 -156 -170 -288 -326 -327 -27 -7 -243 -109 -480 -227 -600 -299 -582 -317 -283 283 118 237 220 453 227 480 39 158 167 285 331 328 30 8 244 109 475 225 231 116 428 211 438 211 9 1 26 -8 37 -19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2513 2799 c-55 -10 -91 -30 -130 -71 -44 -46 -63 -97 -63 -170 1 -143 97 -238 242 -238 142 1 239 98 239 240 1 156 -134 268 -288 239z"
}));

var SvgSalesNavigatorLogo = function SvgSalesNavigatorLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalesNavigatorLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sales-navigator-logo.712a36f7.svg";
export { ForwardRef as ReactComponent };